import { useEffect, useState } from "react"
import filterUtils from "../Utils/filter.utils"

const useFilters = ({
  onFiltersUpdate = () => {}
}) => {
  const [prevSelectedFilters, setPrevSelectedFilters] = useState([]);
  const [selectedFilters, setSelectedFilters] = useState([])

  useEffect(() => {
    if (JSON.stringify(prevSelectedFilters) === JSON.stringify(selectedFilters)) return;
    if (selectedFilters?.some(filter =>
      (filter?.value === null || filter?.value === undefined) 
      || (filter?.type === "checkbox-range" && Array.isArray(filter?.value) && filter?.value?.every(value => value.value === false))
      || (filter?.type === "radio-range" && Array.isArray(filter?.value) && filter?.value?.every(value => value.value === false))
    )) return;
    onFiltersUpdate(selectedFilters);
    setPrevSelectedFilters(selectedFilters);
  }, [selectedFilters]);

  const addFilter = (filter) => {
    setSelectedFilters(prev => {
      const newFilter = filterUtils.createFilter(
        filter?.filterKey,
        filter?.filterTitle,
        filter?.filterValue,
        filter?.filterType
      );
      if (prev.find(prevItem => prevItem.key === filter?.filterKey)) return prev;
      return [...prev, newFilter];  
    })
  }

  return { 
    selectedFilters,
    setSelectedFilters,
    addFilter 
  }
}

export default useFilters;
